export const Guid = {
  Empty: '00000000-0000-0000-0000-000000000000',
  HERO: '8daaef8b-d20c-46fb-a644-9c5046b180d4'
}